const ExcelJS = require('exceljs')

function getLongestVals (e, data) {
  const f = data.reduce((a, b) => Math.max((`${a[e]}`).length, (`${b[e]}`).length))
  return (`${f[e]}`).length
}

function getColumns (data) {
  const result = []
  const keys = Object.keys(data[0])
  keys.forEach(e => {
    const length = getLongestVals(e, data)
    result.push({
      header: e.replace('_', ' '),
      key: e,
      width: length,
    })
  })
  return result
}

const downloadExcel = function (data, name) {
  const blob = new Blob([data], { type: 'application/xlsx' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${name}.xlsx`
  link.click()
  URL.revokeObjectURL(link.href)
}

async function createWorkBook (filePath, fileName, data) {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('records')
  const columns = getColumns(data)
  worksheet.columns = columns
  data.forEach(e => { worksheet.addRow(e) })
  const buffer = await workbook.xlsx.writeBuffer()
  downloadExcel(buffer, fileName)
}

export default createWorkBook
